const ShopActionTypes = {
  UPDATE_COLLECTION: "UPDATE_COLLECTION",
};

export default ShopActionTypes;
